import React from "react"

import { AppFrequenciesAutocomplete } from "@components"


export default function FrequencyAutocomplete({ ...props }) {

    return <AppFrequenciesAutocomplete {...props}/>
}